fragment OrderItemAttachmentFragment on OrderItemAttachment {

    order_item_id

    attachment_variation_id

    attachment_number
    attachment_title

    attachment_variation_number
    attachment_variation_name

    attachment_variation_description

    price
    discount
    total

}